import { ID, IdFilterType } from '../../../../../types';

export const enum UniversalFilterTagIdModes {
  CONTAINS_ANY_OF = 'contains_any_of'
}

export type UniversalFilterTagIdValue = IdFilterType;

export type UniversalFilterTagIdFilterState = {
  mode: UniversalFilterTagIdModes;
  tagIds?: ID[];
};

export type UniversalFilterTagIdOnFilterStateChange = (
  state: UniversalFilterTagIdFilterState
) => void;

export type UniversalFilterTagIdOnChange = (
  value?: UniversalFilterTagIdValue
) => void;
